"use client"

import { ComponentConfig } from "@measured/puck"
import { Spin } from "antd"
import { useState } from "react"
import { twMerge } from "tailwind-merge"
import { CommonStylesProps } from "../../../lib/commonCSSProps"
import { generateResponsiveCSS } from "../../../lib/helper"

// Interface for form props
export interface FormRegisterProps extends CommonStylesProps {}

export const RenderConfig: ComponentConfig<FormRegisterProps> = {
  render: ({ styles, responsiveType, className }) => {
    const id = `form-register-${Math.random().toString(36).substr(2, 9)}`

    const [formData, setFormData] = useState({
      name: "",
      email: "",
      phone: "",
      answer: "",
    })

    const [isPopupVisible, setIsPopupVisible] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [message, setMessage] = useState("")
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const { name, value } = e.target
      setFormData(prev => ({ ...prev, [name]: value }))
    }

    const handleSubmit = async (e: React.FormEvent) => {
      e.preventDefault()
      setIsLoading(true)
      try {
        const response = await fetch("/api/email", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })

        if (!response.ok) {
          throw new Error("Failed to submit data")
        }

        setIsPopupVisible(true)
        setFormData({
          name: "",
          email: "",
          phone: "",
          answer: "",
        })
        setMessage("Đăng ký gian hàng thành công!")
      } catch (error) {
        console.error("Error:", error)
        setMessage("Đã xảy ra lỗi khi đăng ký!")
      } finally {
        setIsLoading(false)
      }
    }

    const closePopup = () => {
      setIsPopupVisible(false)
    }

    const mergedStyles = {
      mobile: { ...styles?.mobile },
      tablet: { ...styles?.tablet },
      desktop: { ...styles?.desktop },
    }

    const responsiveCSS = generateResponsiveCSS(id, mergedStyles || {}, responsiveType)

    return (
      <>
        {responsiveCSS}
        <div className={`${id} ${twMerge(className)} w-full pl-2`}>
          <form onSubmit={handleSubmit} className="space-y-9 max-sm:space-y-3">
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Name"
              className="flex-1 py-3 pl-4 w-full bg-[#F9F9F9] rounded-[15px] placeholder:text-[#a69f9d] focus:outline-none max-sm:placeholder:text-[13px]"
              required
            />
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Email"
              className="flex-1 py-3 pl-4 w-full bg-[#F9F9F9] rounded-[15px] placeholder:text-[#a69f9d] focus:outline-none max-sm:placeholder:text-[13px]"
              required
            />
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Phone"
              className="flex-1 py-3 pl-4 w-full bg-[#F9F9F9] rounded-[15px] placeholder:text-[#a69f9d] focus:outline-none max-sm:placeholder:text-[13px]"
              required
            />
            <textarea
              name="company"
              value={formData.answer}
              onChange={handleChange}
              placeholder="Add answer here"
              rows={4}
              className="flex-1 py-3 pl-4 w-full bg-[#F9F9F9] rounded-[15px] placeholder:text-[#a69f9d] focus:outline-none max-sm:placeholder:text-[13px]"
              required
            />
            <div className="flex justify-center pt-[10px]">
              <button
                type="submit"
                className="py-[8px] bg-[#3BC873] text-white font-semibold text-base leading-7 rounded-[40px] text-center whitespace-nowrap w-[147px] h-[42px] hover:bg-[#323232] max-sm:text-[15px] max-sm:w-[120px] max-sm:font-medium"
              >
                Submit
              </button>
            </div>
          </form>

          {isLoading && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <Spin />
            </div>
          )}

          {isPopupVisible && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div className="bg-white p-8 rounded shadow-md relative">
                <button
                  onClick={closePopup}
                  className="absolute top-0 text-[30px] right-2 text-gray-600 hover:text-gray-800"
                  aria-label="Close"
                >
                  &times;
                </button>
                <p className="text-lg font-semibold">{message}</p>
              </div>
            </div>
          )}
        </div>
      </>
    )
  },
}
